// modals/store/StoreDetailModal.js
import React, { useEffect, useRef, useState } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import VerticalFlex from "layouts/flex/VerticalFlex";
import ModalBase from "modals/base/ModalBase";
import { useTranslation } from "react-i18next";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";

import customMarker from "resources/img/puffu/main/marker.svg"; // 커스텀 마커 이미지 임포트
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Dummy from "components/Dummy";
import StoreManagementDetail from "./StoreManagementDetail";

const StoreManagementDetailModal = NiceModal.create(({ store }) => {
    const { t } = useTranslation();
    const [withHeader, withFooter] = [true, false];
    const [width, height] = ["initial", "initial"];
    const withCloseButton = true;
    const modal = useRef();
    const clickOutsideToClose = true;
    const title = store.storeName;
    const buttonText = t("close");

    return (
        <ModalBase
            ref={modal}
            width={width}
            height={height}
            withHeader={withHeader}
            withFooter={withFooter}
            withCloseButton={withCloseButton}
            clickOutsideToClose={clickOutsideToClose}
            title={title}
            buttonText={buttonText}
            overflow={"visible"}
            backgroundColor={"var(--bg-color)"}
        >
                <StoreManagementDetail data={store} />
        </ModalBase>
    );
});

export default StoreManagementDetailModal;
